export default __webpack_public_path__ + "static/media/recommend.59d4d44a.jpg";